import { FormItemController } from "./FormItemController";
import { Dropdown } from "../../HTML/Form/Item/Dropdown";
import { Select } from "../../HTML/Form/Item/Select";
import { Selector } from "../../HTML/Editor/Selector";
import { toMap } from "../../../../HA";

/**
 * Contrôleur du champ select/dropdown. Premier input « classique » à offrir le
 * MODE d'entrée modal en OPTION (ha/444) : par défaut rendu inline (`<select>`
 * natif via Dropdown) ; si le champ porte `entry="modal"`, il réutilise le
 * mécanisme partagé `attachModalEntry` (même fonctionnement que slct) avec un
 * style optionnel `entrystyle` — même éditeur, skin paramétrable.
 */
export class DropdownController extends FormItemController {

    public isInputItem() {
        return true;
    }

    public getValue() {
        // Modal : la valeur vit dans l'item Select (sélections) ; inline : valeur
        // du <select> natif (Dropdown.getValue).
        return this.get("_modalEntry")
            ? this.getTag().getSelected()
            : this.getTag().getValue();
    }

    protected createItem() {
        const element = this.getTag().findByAttribute("ft");
        const entry = element ? element.getAttribute("entry") : null;
        const data = toMap({tag: this.getTag()});

        if (entry === "modal") {
            const style = element ? element.getAttribute("entrystyle") : null;
            this.addToData("_modalEntry", true);
            this.attachModalEntry(
                data,
                (cfg) => new Selector(cfg),
                { style: style || undefined },
            );
            // Affichage : item Select (montre la sélection + ouvre la modale au clic).
            return new Select(data);
        }

        // Défaut : <select> natif inline.
        return new Dropdown(data);
    }

    protected getChoices() {
        return this.getTag().getChoices();
    }

    protected replaceItems(items: any[]) {
        this.getTag().replaceItems(items);
    }
}
